import * as React from "react"
import {
  BooleanField,
  CreateButton,
  DatagridConfigurable,
  DateField,
  DateInput,
  ExportButton,
  List,
  NullableBooleanInput,
  NumberField,
  SearchInput,
  SelectColumnsButton,
  TopToolbar,
  TextField,
  EmailField,
  useListContext,
  DeleteButton,
  useRecordContext,
  EditButton,
  DeleteWithConfirmButton,
  BulkDeleteButton
} from "react-admin"
import { useMediaQuery, Button, Box, Typography } from "@mui/material"
import ContentFilter from '@mui/icons-material/FilterList';

import MemberFilterForm from "./MemberFilterForm"

const MemberFilterButton = () => {
  const { showFilter } = useListContext()
  return (
    <Button
      size="small"
      color="primary"
      onClick={() => showFilter("main")}
      startIcon={<ContentFilter />}
      sx={{
        height: '27.5px', // 調整按鈕高度
        padding: '4px 5px', // 調整內邊距
        fontSize: '13px', // 調整字型大小，這樣可以與 CreateButton 大小對齊
      }}
    >
      篩選
    </Button>
  )
}

const visitorFilters = [
  <SearchInput source="q" alwaysOn />,
  // <DateInput source="last_seen_gte" />,
  // <NullableBooleanInput source="has_ordered" />,
  // <NullableBooleanInput source="has_newsletter" defaultValue />,
  // <SegmentInput source="groups" />
]

const ContactListActions = () => (
  <Box width="100%">
    <TopToolbar>
      <MemberFilterButton />
      <CreateButton />
      {/* <SelectColumnsButton /> */}
      {/* <ExportButton /> */}
    </TopToolbar>
    <MemberFilterForm />
  </Box>
)

const MemberBulkActionButtons = () => (
  <>
    <BulkDeleteButton 
      confirmTitle="確認刪除"
      confirmContent="您確定要刪除這些會員嗎？"
      mutationMode="optimistic"
    />
  </>
);

const MemberTitle = () => {
  return <span>{'會員'}</span>;
};

const MemeberList = () => {
  const isXsmall = useMediaQuery(theme => theme.breakpoints.down("sm"))
  const isSmall = useMediaQuery(theme => theme.breakpoints.down("md"))
  return (
    <List
      title={<MemberTitle/>}
      filters={isSmall ? visitorFilters : undefined}
      sort={{ field: "createdAt", order: "DESC" }}
      perPage={25}
      // aside={<ContactListAside />}
      actions={<ContactListActions />}
    >
      {isXsmall ? (
        // <MobileGrid />
        <div></div>
      ) : (
        <DatagridConfigurable
          rowClick="edit"
          bulkActionButtons={<MemberBulkActionButtons />}
          sx={{
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" }
            }
          }}
          omit={["id"]}
        >
          <TextField
            source="id"
            label="ID"
          />
          <TextField
            source="code"
            label="編號"
          />
          <TextField
            source="name"
            label="名稱"
          />
          <TextField
            source="account"
            label="名稱"
          />
          <EmailField
            source="email"
            label="電子郵件"
          />
          <TextField
            source="mobile"
            label="手機號碼"
          />
          <BooleanField
            source="status"
            label="起用狀態"
          />
          <DateField 
            source="createdAt" 
            label="建立日期"  
            showTime
          />
          <DeleteWithConfirmButton
            confirmTitle="確認刪除"
            confirmContent="您確定要刪除此會員嗎？"
          />
        </DatagridConfigurable>
      )}
    </List>
  )
}

export default MemeberList